// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Rubik/Rubik-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Rubik';
  src: local('FiraSans'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

* {
  box-sizing: border-box;
}

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}

body {
  font-family: 'Rubik', sans-serif;
  margin: 0;
  color: #313131;
  font-size: 1rem;
}

a, button {
	font-family: 'Rubik', sans-serif;
  	text-decoration: none;
  	color: inherit;
}

/* TITLES */
h1{line-height:48px;font-size:36px}
h2{line-height:36px;font-size:24px}
h3{line-height:30px;font-size:21px}
h4{line-height:22px;font-size:18px}
h5{font-size:16px;font-size:14px}
`, "",{"version":3,"sources":["webpack://./src/assets/styles.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kFAAyE;AAC3E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;CAaC,SAAS;CACT,UAAU;CACV,SAAS;CACT,eAAe;CACf,aAAa;CACb,wBAAwB;AACzB;AACA,gDAAgD;AAChD;;CAEC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;AACA;CACC,YAAY;AACb;AACA;;CAEC,WAAW;CACX,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;EACE,gCAAgC;EAChC,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;CACC,gCAAgC;GAC9B,qBAAqB;GACrB,cAAc;AACjB;;AAEA,WAAW;AACX,GAAG,gBAAgB,CAAC,cAAc;AAClC,GAAG,gBAAgB,CAAC,cAAc;AAClC,GAAG,gBAAgB,CAAC,cAAc;AAClC,GAAG,gBAAgB,CAAC,cAAc;AAClC,GAAG,cAAc,CAAC,cAAc","sourcesContent":["@font-face {\r\n  font-family: 'Rubik';\r\n  src: local('FiraSans'), url(./Rubik/Rubik-Regular.ttf) format('truetype');\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml, body, div, span, applet, object, iframe,\r\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\r\na, abbr, acronym, address, big, cite, code,\r\ndel, dfn, em, img, ins, kbd, q, s, samp,\r\nsmall, strike, strong, sub, sup, tt, var,\r\nb, u, i, center,\r\ndl, dt, dd, ol, ul, li,\r\nfieldset, form, label, legend,\r\ntable, caption, tbody, tfoot, thead, tr, th, td,\r\narticle, aside, canvas, details, embed, \r\nfigure, figcaption, footer, header, hgroup, \r\nmenu, nav, output, ruby, section, summary,\r\ntime, mark, audio, video {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tborder: 0;\r\n\tfont-size: 100%;\r\n\tfont: inherit;\r\n\tvertical-align: baseline;\r\n}\r\n/* HTML5 display-role reset for older browsers */\r\narticle, aside, details, figcaption, figure, \r\nfooter, header, hgroup, menu, nav, section {\r\n\tdisplay: block;\r\n}\r\nbody {\r\n\tline-height: 1;\r\n}\r\nol, ul {\r\n\tlist-style: none;\r\n}\r\nblockquote, q {\r\n\tquotes: none;\r\n}\r\nblockquote:before, blockquote:after,\r\nq:before, q:after {\r\n\tcontent: '';\r\n\tcontent: none;\r\n}\r\ntable {\r\n\tborder-collapse: collapse;\r\n\tborder-spacing: 0;\r\n}\r\n\r\nbody {\r\n  font-family: 'Rubik', sans-serif;\r\n  margin: 0;\r\n  color: #313131;\r\n  font-size: 1rem;\r\n}\r\n\r\na, button {\r\n\tfont-family: 'Rubik', sans-serif;\r\n  \ttext-decoration: none;\r\n  \tcolor: inherit;\r\n}\r\n\r\n/* TITLES */\r\nh1{line-height:48px;font-size:36px}\r\nh2{line-height:36px;font-size:24px}\r\nh3{line-height:30px;font-size:21px}\r\nh4{line-height:22px;font-size:18px}\r\nh5{font-size:16px;font-size:14px}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
